import seedrandom from "seedrandom";

const RANDOM_SEED_PREFIX =
  process.env.RANDOM_LOCATION_SEED_BASE ?? "venturu_seeded_coords";

export function randomCoordsFromCenter(
  center: {
    latitude: number | null;
    longitude: number | null;
  },
  radius: number,
  rng: () => number = Math.random,
) {
  if (!center.latitude || !center.longitude) {
    return {
      latitude: null,
      longitude: null,
    };
  }

  const r = radius / 111300; // = 100 meters

  const a = rng();
  const b = rng();

  const w = r * Math.sqrt(a);
  const t = 2 * Math.PI * b;
  const x = w * Math.cos(t);
  const y = w * Math.sin(t);

  return {
    latitude: center.latitude + y,
    longitude: center.longitude + x,
  };
}

export function seededRandomCoordsFromCenter(
  seed: string,
  center: {
    latitude: number | null;
    longitude: number | null;
  },
  radius: number,
): {
  latitude: number | null;
  longitude: number | null;
} {
  const rng = seedrandom(`${RANDOM_SEED_PREFIX}_${seed}`);
  return randomCoordsFromCenter(center, radius, rng);
}
